// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getUserUndeletedTopLevelAnnotationCount = async ({
    test,
}: {
    test: boolean,
}): Promise<number> => {
    const functions = getFunctions();
    const handleGetUserUndeletedTopLevelAnnotationCount = httpsCallable<
        Record<
            string,
            boolean
        >,
        number
    >(
        functions,
        'getUserUndeletedTopLevelAnnotationCount',
    );
    return handleGetUserUndeletedTopLevelAnnotationCount({
        test,
    }).then((result) => {
        const count = result.data as number;
        return count;
    }).catch((err) => {
        throw err;
    });
};

export default getUserUndeletedTopLevelAnnotationCount;
